import React, { useEffect, useMemo, useState } from 'react';
import { latLngToCell } from 'h3-js';
import { API_GATEWAY_URL, H3_HEXAGON_RES, IS_PRODUCTION } from './utils';
import { useSessionContext } from './SessionContext';
import GeoSearch, { FetchingLocationBar } from './GeoSearch';
import LocationPanel from './LocationPanel';

const getLocationFromSearchResult = async ({ placeID }) => {
  const url = new URL(`${API_GATEWAY_URL}/location`);
  const params = new URLSearchParams({
    placeID,
    source: IS_PRODUCTION ? 'wli-map' : 'debug'
  });
  const response = await fetch(`${url}?${params}`);
  const data = await response.json();
  return data;
};

export default function LeftPanel() {
  const { selectedLocation, setSelectedLocation } = useSessionContext();
  const [selectedSearchResult, setSelectedSearchResult] = useState();

  useEffect(() => {
    if (!selectedSearchResult) return;
    const task = async () => {
      const location = await getLocationFromSearchResult(selectedSearchResult);
      const { lat, lng } = location;
      setSelectedSearchResult();
      setSelectedLocation({ ...location, hexagonCode: latLngToCell(lat, lng, H3_HEXAGON_RES) });
    };
    task();
  }, [selectedSearchResult]);

  const leftPanelContents = useMemo(() => {
    if (selectedLocation) return <LocationPanel />;
    if (selectedSearchResult) return <FetchingLocationBar />;
    return <GeoSearch setSelectedSearchResult={setSelectedSearchResult} />;
  }, [selectedLocation, selectedSearchResult, setSelectedSearchResult]);

  return (
    <div className="left-panel">
      {leftPanelContents}
    </div>
  );
}
